/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsectionaddress3Inputs */

const en_placewebsectionaddress3 = /** @type {(inputs: Placewebsectionaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const de_placewebsectionaddress3 = /** @type {(inputs: Placewebsectionaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Placewebsectionaddress3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsectionaddress3 = /** @type {((inputs?: Placewebsectionaddress3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsectionaddress3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsectionaddress3(inputs)
	return de_placewebsectionaddress3(inputs)
});
export { placewebsectionaddress3 as "placeWebSectionAddress" }